<template>
	<input
		type="search"
		v-model="query"
		placeholder="Keyword"
		name="search-input"
		id="search-input"
		ref="searchInput"
		autofocus
	/>
</template>

<script>
	import { connectSearchBox } from "instantsearch.js/es/connectors";
	import { createWidgetMixin } from "vue-instantsearch/vue3/es";
	import { history } from "instantsearch.js/es/lib/routers";

	export default {
		mixins: [createWidgetMixin({ connector: connectSearchBox })],
		props: {
			delay: {
				type: Number,
				default: 200,
				required: false,
			},
		},
		data() {
			return {
				timerId: null,
				localQuery: "",
				routing: {
					router: history({
						writeDelay: 400,
					}),
				},
			};
		},
		mounted() {
			var urlQuery = this.parseQueryString();

			if (urlQuery.query) {
				this.$refs.searchInput.value = urlQuery.query;
			}
		},
		destroyed() {
			if (this.timerId) {
				clearTimeout(this.timerId);
			}
		},
		computed: {
			query: {
				get() {
					return this.localQuery;
				},
				set(val) {
					this.localQuery = val;
					if (this.timerId) {
						clearTimeout(this.timerId);
					}
					this.timerId = setTimeout(() => {
						this.state.refine(this.localQuery);
					}, this.delay);
				},
			},
		},
		methods: {
			parseQueryString: function () {
				var urlQueryString = document.location.search;
				var query = {};
				var pairs = (
					urlQueryString[0] === "?" ? urlQueryString.substr(1) : urlQueryString
				).split("&");

				for (var i = 0; i < pairs.length; i++) {
					var pair = pairs[i].split("=");
					query[decodeURIComponent(pair[0])] = decodeURIComponent(
						pair[1] || ""
					);
				}
				return query;
			},
		},
	};
</script>
